<template>
    <section id="footer">
      <div class="section-container">
        
        <!-- Links -->
        <div id="footer_links">
          <div class="wrapper">
            <div class="card">
              <h3><a href="#!">Products</a></h3>
              <ul>
                <!-- do not't change code, just send Bo's pdf and bo will upload the new pdf to media/documents/linecard.pdf  -->
                <li><a href="/media/catalog/index.html" target="blank">Catalog</a></li>
                <li><a href= "/media/documents/linecard.pdf" target="blank">Line Card</a></li>
              </ul>
            </div>
          </div>

          <div class="wrapper">
            <div class="card">
              <h3><a href="#!">Solutions</a></h3>
              <ul>
                <li><router-link :to="{ name: 'EnterpriseSolutions' }">Enterprise Solutions</router-link></li>
                <li><router-link :to="{ name: 'ServerSolutions' }">Server & Storage Solutions</router-link></li>
                <!-- <li><router-link :to="{ name: 'MiningSolutions' }">Mining Solutions</router-link></li> -->
                <li><router-link :to="{ name: 'IndustrialSolutions' }">Industrial Solutions</router-link></li>
                <li><router-link :to="{ name: 'GamingSolutions' }">Gaming Solutions</router-link></li>               
                <li><router-link :to="{ name: 'EdgeSolutions' }">Edge Solutions</router-link></li>
                <li><router-link :to="{ name: 'DigitalSolutions' }">Digital Solutions</router-link></li>
              </ul>
            </div>
          </div>

          <div class="wrapper">
            <div class="card">
              <h3><a href="#!">Partners</a></h3>
              <ul>
                <!-- <li><router-link :to="{ name: 'Partners' }">Our Partners</router-link></li> -->
                <li><router-link :to="{ name: 'FeaturedStores' }">Featured Stores</router-link></li>

              </ul>
            </div>
          </div>

          <div class="wrapper">
            <div class="card">
              <h3><a href="#!">Company</a></h3>
              <ul>
                <li><router-link :to="{ name: 'About' }">Overview</router-link></li>
                <li><router-link :to="{ name: 'RecognitionsAndSpotlights' }">Recognitions & Spotlights</router-link></li>
                <li><router-link :to="{ name: 'Events' }">Events</router-link></li>
                <li><router-link :to="{ name: 'Careers' }">Careers</router-link></li>
                <li><router-link :to="{ name: 'EmailNewsletters' }">Email Newsletters</router-link></li>
                <li><router-link :to="{ name: 'Branches' }">Our Branches</router-link></li>
                <li><a href ="/media/catalog/logo.zip">Logo</a></li>
              </ul>
            </div>
          </div>

          <div class="wrapper">
            <div class="card">
              <h3><a href="#!">My Account</a></h3>
              <ul>
                <li><router-link :to="{ name: 'AccountOverview' }">Account Management</router-link></li>
                <li><router-link :to="{ name: 'RegisterAccountLink' }">Web Account Register</router-link></li>
                <li><router-link :to="{ name: 'Cart' }">Shopping Cart</router-link></li>
                <li><router-link :to="{ name: 'ShipmentTracking'}">Order Status</router-link></li>
              </ul>
            </div>
          </div>

          <div class="wrapper">
            <div class="card">
              <h3><a href="#!">Support</a></h3>
              <ul>               
                <li><router-link :to="{ name: 'ContactUs',params: { topic:'-' }}">Contact US</router-link></li>
                <li><router-link :to="{ name: 'RMARequest' }">RMA Request</router-link></li>
                <li><router-link :to="{ name: 'FAQ' }">FAQ</router-link></li>
              </ul>
            </div>
          </div>

          <div class="wrapper">
            <div class="card">
              <h3><a href="#!">Connect</a></h3>
              <ul class="d-flex list-unstyled gap-2 justify-content-center">               
                <li>
                  <a class="d-inline-flex align-items-center justify-content-center rounded"
                   href="https://www.linkedin.com/company/malabs"
                   target="_blank"
                  >
                    <img class="connect-logo" src="@/assets/images/linkedin_icon_36px.png">
                  </a>
                </li>
                <li>
                  <a class="d-inline-flex align-items-center justify-content-center rounded"
                   href="https://x.com/MaLabs_Inc"
                   target="_blank"
                  >
                    <img class="connect-logo" src="@/assets/images/twitter_icon_36px.png">
                  </a>
                </li>
                <li>
                  <a class="d-inline-flex align-items-center justify-content-center rounded"
                   href="https://www.instagram.com/malabs_inc"
                   target="_blank"
                  >
                    <img class="connect-logo" src="@/assets/images/instagram_icon_36px.png">
                  </a>
                </li>
                <li>
                  <a class="d-inline-flex align-items-center justify-content-center rounded"
                   href="https://www.youtube.com/@MaLabs_Inc"
                   target="_blank"
                  >
                    <img class="connect-logo" src="@/assets/images/youtube_icon_36px.png">
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>


        <!-- Copyright -->
        <div id="copyright">
          <p>Copyright &copy;  Ma Laboratories, Inc. All Rights Reserved</p>
          <div>
            <router-link :to="{ name: 'Disclaimer'}">Disclaimer</router-link>| 
            <router-link :to="{ name: 'TermsAndConditions'}">Terms&nbsp;And&nbsp;Conditions</router-link> | 
            <router-link :to="{ name: 'PrivacyPolicy'}">Privacy&nbsp;Policy</router-link> | 
            <router-link :to="{ name: 'CookieNotice'}">Cookie&nbsp;Notice</router-link>
          </div>
        </div>

      </div>
    </section>

    <!-- newsletter subscribe layer -->
    <div id="subscribe" class="stick_bottom" style="z-index: 9999;">
      <div class="center">

          <div class="center_content">
            <div class="float me-3"><img src="@/assets/images/notebook_image.png" /></div>
            <div class="float me-3"><img src="@/assets/images/gift_card_image.png" /></div>
            <div class="float me-3">
              <table>
                <tr>
                  <td class="subscribe_text">Subscribe to Our Newsletter to win a <span class="gold">Notebook</span> or <span class="gold">Gift Card!</span></td>
                </tr>
                <tr>
                  <td align="right" class="subscribe_text_sm">*For more details, please refer to our <a href="https://www.subscribepage.com/signup-to-win" target="_blank">Terms & Conditions.</a></td>
                </tr>
              </table>
            </div>
            <div class="float"><a class="btn subscribe_btn" href="/company/newsletter">Subscribe</a></div>
          </div>

          <a id="close_x" @click="closeSubscribe"><i class="bi bi-x-circle-fill"></i></a>
      </div>
    
	</div>

  <!-- cookie accept layer -->
  <div id="cookies" style="z-index: 9999">
    <div class="cookie-content">
      <p>
        This website uses cookies and similar technologies to provide essential functionality. With your consent, 
        we also use analytics cookies to improve website performance and deliver relevant content. 
        Select "Accept All" to allow these optional cookies or "Reject All" to limit cookie use to strictly necessary 
        cookies only. For more information, please review 
        our <a href="/company/privacy-policy">Privacy Policy</a> and <a href="/company/cookie-notice">Cookie Notice</a>.
      </p>
      <div class="cookie-actions">
        <button class="btn btn-light" data-bs-toggle="modal" data-bs-target="#cookieSettingsModal">Cookie Options</button>
        <button class="btn" @click="declineCookies">Reject All</button>
        <button class="btn" @click="acceptCookies">Accept All</button>  
      </div>
    </div>
    <form id="cookie_notice" method="POST">
      <input type="hidden" id="accept_cookie" name="accept_cookie">
    </form>
    <a id="close_cookies" @click="declineCookies"><i class="bi bi-x-lg"></i></a>
  </div>

  <!-- Floating Cookie Trigger Icon (Shows only when #cookies div is hidden) -->
  <button 
    v-if="isCookieBannerHidden" 
    class="cookie-float-btn" 
    data-bs-toggle="modal" 
    data-bs-target="#cookieSettingsModal"
    aria-label="Open Cookie Settings"
    title="Cookie Settings"
  >
    <i class="bi bi-shield-lock-fill"></i>
  </button>

  <!-- Bootstrap 5 Cookie Settings Modal Window -->
  <div class="modal fade" id="cookieSettingsModal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="cookieSettingsModalLabel" aria-hidden="true" style="z-index: 10000;">
    <div class="modal-dialog modal-dialog-centered modal-lg text-dark">
      <div class="modal-content px-4 py-3">
        <div class="modal-header">
          <h4 class="modal-title" id="cookieSettingsModalLabel">Cookie Privacy Settings</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelCookiePreferences"></button>
        </div>
        <div class="modal-body">
          <p class="text-muted ">
            We value your privacy and respect your choices regarding your data. You can manage your cookie preferences below. 
            Strictly necessary cookies are required for the website to function properly. Optional analytics cookies help us 
            improve website performance and provide relevant content. For more information on how we collect and safeguard your 
            information, please review our
            <a href="/company/privacy-policy" target="_blank" class="text-primary text-decoration-underline">Privacy Policy</a> 
            and <a href="/company/cookie-notice" target="_blank" class="text-primary text-decoration-underline">Cookie Notice</a>.

          </p>
          
          <!-- Strictly Necessary Cookies Row -->
          <div class="d-flex flex-column mb-2 w-100 border rounded p-3 bg-light">
            <div>
              <div class="d-flex align-items-center justify-content-between mb-1 w-100">
                <label class="fw-bold me-2" id="essentialCookiesLabel" for="essentialCookies">Strictly Necessary Cookies</label>
                <div class="form-check form-switch pt-0 text-nowrap">
                  <span class="text-primary fw-bold small d-inline-flex align-items-center">
                    <i class="bi bi-check-lg me-1"></i>Always Active
                  </span>
                </div>
              </div>
              <p class="text-muted mb-0">
                These essential cookies are required to enable secure user authentication, core site navigation, and critical safeguards that protect our website from attacks. Without them, the website cannot function properly, which is why they must remain active at all times and cannot be disabled.
              </p>
            </div>
          </div>
          
          <!-- Performance & Analytics Cookies Row -->
          <div class="d-flex align-items-start justify-content-between border rounded p-3 bg-light">
            <div class="me-3">
              <label class="fw-bold d-block" id="analyticsCookiesLabel" for="analyticsCookies">Performance & Analytics Cookies</label>
              <p class="text-muted mb-0">These optional cookies help us understand how visitors use our website by collecting aggregated analytics data. The information is used to measure site performance, identify usability issues, and improve the overall user experience.</p>
               
            </div>
            <div class="form-check form-switch pt-1 custom-switch-lg">
              <input class="form-check-input" type="checkbox" id="analyticsCookies" v-model="allowAnalytics">
            </div>
          </div>

        </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="cancelCookiePreferences">Cancel</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveCookiePreferences">Confirm my choices</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { getAPI } from '../../utils/axios-api'
import { getCookie, formatDateTime } from '../../utils/common'
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { BackendDomain } from "../../utils/settings.js";
import { bootstrap } from 'vue-gtag'
import { MeasurementId } from "../../utils/settings.js"

export default {
  setup(props, context) {
    const store = useStore()
    const isSubscribed = store.getters.isSubscribed
    const user = JSON.parse(localStorage.getItem("user"))
    const emailaddr = ref(null)
    
    // Checkbox initialization state
    const allowAnalytics = ref(false);

    const isCookieBannerHidden = ref(false);

    function showSubscribe() {
      //turn off subscribe layer on 6/6/2023, requested by Elena since the event is over
      return false

      //no need to show subscribe layer when user logged in and is subscribed already
      if (!!user && isSubscribed) return false

      //if user not logged in, or user is not subscribed, check if user has previously closed subscribe layer. 
      //if user closed it already, do not to show it again.
      if (getCookie('subscribeclose')) return false

      return true
    }


    onMounted(() => {

      //Check if malabs cookie notice is accepted or not
      //If not, show cookie notice accept button
      if (getCookie('cookienotice') === "") {
        let tag = document.getElementById("cookies");
        tag.style = "display:table;"
        isCookieBannerHidden.value = false;
      }
      else {
        isCookieBannerHidden.value = true;
      }

      const cookieModalElement = document.getElementById('cookieSettingsModal');
      if (cookieModalElement) {
        cookieModalElement.addEventListener('show.bs.modal', () => {
          const savedCookie = getCookie('cookienotice');
          
          // If cookienotice is "1", the user previously allowed analytics.
          // Otherwise, default/fallback to false.
          if (savedCookie === "1") {
            allowAnalytics.value = true;
          } else {
            allowAnalytics.value = false;
          }
        });
      }

      //if cookie notice is accepted, show subscribe layer
      if (getCookie('cookienotice') === "1") {
        if (showSubscribe()) {
          let tag = document.getElementById("subscribe");
          tag.style = "display:table;"
        }
      }

      //added ada by zoe

      const script = document.createElement('script');
      const head = document.querySelector('head') || document.body;
      console.log(head)
      script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
      script.async = true;
      script.onload = () => {
        acsbJS.init({
          statementLink: '',
          footerHtml: '',
          hideMobile: false,
          hideTrigger: false,
          disableBgProcess: false,
          language: 'en',
          position: 'left',
          leadColor: '#146FF8',
          triggerColor: '#146FF8',
          triggerRadius: '50%',
          triggerPositionX: 'left',
          triggerPositionY: 'bottom',
          triggerIcon: 'people',
          triggerSize: 'bottom',
          triggerOffsetX: 20,
          triggerOffsetY: 90,
          mobile: {
            triggerSize: 'small',
            triggerPositionX: 'left',
            triggerPositionY: 'bottom',
            triggerOffsetX: 10,
            triggerOffsetY: 90,
            triggerRadius: '20',
          },
        });
      };
      head.appendChild(script);

    });
    
    
    //accept cookie
    const acceptCookies = () => {
      var d = new Date();
      var cur_timestamp = formatDateTime(d)

      var exdays = 3650;
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();

      document.cookie = "cookienotice=1" + ";" + expires + "; path=/";
      document.cookie = "cookienoticetime=" + cur_timestamp + ";" + expires + "; path=/";

      let tag = document.getElementById("cookies");
      tag.style = "display:none;"
      isCookieBannerHidden.value = true;

      // Grant consent and load Google Analytics for the first time
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'analytics_storage': 'granted',
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted'
        });
      }
      bootstrap();   // injects gtag.js now — not before

      //if cookie notice is accepted, show subscribe layer
      if (getCookie('cookienotice') === "1") {
        if (showSubscribe()) {
          let tag = document.getElementById("subscribe");
          tag.style = "display:table;"
        }
      }      
    }

    //decline cookie
    const declineCookies = () => {
      var d = new Date();
      var cur_timestamp = formatDateTime(d)

      var exdays = 3650;
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();

      // Record the decline. Value "0" (not "1") means index.html and main.js
      // will NOT grant consent or bootstrap GA — now or on future visits.
      document.cookie = "cookienotice=0" + ";" + expires + "; path=/";
      document.cookie = "cookienoticetime=" + cur_timestamp + ";" + expires + "; path=/";

      // 1. Tell GA to explicitly deny tracking via consent mode
      // Keep analytics explicitly denied. gtag.js is never loaded here, so
      // nothing is sent to Google.
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'analytics_storage': 'denied',
          'ad_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied'
        });
      }

      // 2. HARD OPT-OUT KILL SWITCH (Ensures no data leaves the browser)
      // MeasurementId is imported from utils/settings.js
      if (MeasurementId) {
        window[`ga-disable-${MeasurementId}`] = true;
      }
      
      // 3. CLEAN UP EXPIRED/EXISTING COOKIES
      const cookiesToRemove = ['_ga', `_ga_${MeasurementId.replace('G-', '')}`];

      // Get variations of the domain to cross-examine
      const host = window.location.hostname;
      const hostParts = host.split('.');
      let rootDomain = host;

      // If on a standard domain (e.g., www.example.com), extract the root (example.com)
      if (hostParts.length > 2) {
        rootDomain = hostParts.slice(-2).join('.');
      }

      cookiesToRemove.forEach(cookieName => {
        // 1. Try deleting with no domain specified (defaults to current host)
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        
        // 2. Try deleting with the exact current host
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${host};`;
        
        // 3. Try deleting with a leading dot on the host
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${host};`;
        
        // 4. Try deleting on the root domain (most common for GA)
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${rootDomain};`;
        
        // 5. Try deleting with a leading dot on the root domain (.example.com)
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${rootDomain};`;
      });

      let tag = document.getElementById("cookies");
      tag.style = "display:none;"
      isCookieBannerHidden.value = true;
    }

    // Evaluates state dynamically upon Modal closing workflow
    const saveCookiePreferences = () => {
      if (allowAnalytics.value) {
        acceptCookies();
      } else {
        declineCookies();
      }
    }

    const cancelCookiePreferences = () => {
      allowAnalytics.value = false;
      if (getCookie('cookienotice') === "1") {
        allowAnalytics.value = true;
      }
    }

    const closeSubscribe = () => {
      var d = new Date();
      var cur_timestamp = formatDateTime(d)

      var exdays = 3650;
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();

      document.cookie = "subscribeclose=1" + ";" + expires + "; path=/";
      document.cookie = "subscribeclosetime=" + cur_timestamp + ";" + expires + "; path=/";

      let tag = document.getElementById("subscribe");
      tag.style = "display:none;"
    }

  return {acceptCookies, 
          declineCookies, 
          saveCookiePreferences, 
          cancelCookiePreferences,
          allowAnalytics,
          isCookieBannerHidden,
          BackendDomain, 
          closeSubscribe, 
          emailaddr};
  },
};
</script>


<style scoped>
#footer {
  position: relative;
  min-width: 300px;
  min-height: 100vh;
  padding: 65px 30px;

  font-family: Segue, Arial;
  color: #575757;
  background: #E8E8E8;
  clear: both;
}


#footer a {
  color: #828282;
  font-size: 16px;
}
#footer a:hover {
  color: #828282 !important;
  text-decoration: underline;
}
#footer h3 {
  font-size: 18px;
  text-transform: none;
}
#footer h3 a {
  color: #141414 !important;
}
#footer h3 a:hover {
  color: #141414 !important;
  text-decoration: underline;
}


/* Desktop */
@media (min-width: 1035px) {
  #footer {
    min-height: 0;
  }
}


/* Footer links */
#footer_links {
  position: relative;
  font-size: 12px;
  overflow: hidden;
}
#footer_links .wrapper {
  float: left;
  width: 50%;
  height: auto;
}
#footer_links .wrapper:nth-child(n+3):nth-child(-n+4) {
  height: 310px;
}
#footer_links .card {
  padding: 0;
  background: none;
  border: none;
}
#footer_links h3 {
  font-family: Roboto Bold;
  color: #fff;
  font-size: 16px;
}
#footer_links a {
  color: #828282;
  font-size: 16px;
  text-decoration: none;
}
#footer_links .card ul {
  display: table;
  padding: 0 2px;
  list-style-type: none;
}
#footer_links .card li {
  margin: 10px 0;
}
.connect-logo {
  width: 80%;
  height: auto;
}

#cookies {
	display: none;
	z-index: 70;
	position: fixed;
	bottom: 0;
	width: 100%;
	/* padding: 20px 30px; */
  padding: 20px 45px 20px 30px;
	background: rgba(80, 80, 80, 0.85);
}
#cookies {
  color: #fff;
    display: none;
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 20px 45px 20px 30px;
    background: rgba(80,80,80,.85);
}
.cookie-content{
    display:flex;
    align-items:center;
    gap:24px;
}

.cookie-content p{
    flex:1;
    margin:0;
}

.cookie-actions{
    display:flex;
    gap:10px;
    flex-shrink:0;
}

#cookies a {
	color: #fff;
	text-decoration: underline;
}



#cookies .cookie-actions button.btn {
    white-space: nowrap;
}

/* ADDED: Mobile responsive fix for cookie wrapper */
@media (max-width: 950px) {
  .cookie-content{
    flex-wrap:wrap;
}

.cookie-content p{
    flex-basis:100%;
}

.cookie-actions{
    width:100%;
    justify-content:flex-end;
}
}

/* button.btn + !important beats any leftover global "#cookies button" rule */
#cookies .cookie-actions button.btn {
	position: static !important;
	float: none !important;
	display: inline-block;
	padding: 5px 24px;
	color: #000;
	background: #fff;
	font-family: Roboto Medium;
	font-size: 16px;
	border: 1px solid #fff;
	border-radius: 4px;
	cursor: pointer;
}
#close_cookies {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #888;
  cursor: pointer;
  font-size: 16px;
}
#close_cookies:hover {
  color: #eee;
}
.stick_bottom {
	display: none;
	z-index: 70;
	position: fixed;
	bottom: 0;
	width: 100%;
}
.stick_bottom p {
	float: left;
	width: calc(100% - 112px - 40px);
	color: #fff;
}
.stick_bottom a {
	color: #fff;
	text-decoration: underline;
}
.stick_bottom label {
  color: #fff;
  padding-top:0.5em;
}
.center{
  position: relative;
  width:90%;
  margin: auto;
  padding: 20px 30px 10px;
  background: rgba(11, 32, 48, 0.87);
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.center_content {
  display:table; margin:auto;
}
.subscribe_text {
  font-family: Segoe, Arial;
  font-weight: bold;
  font-size:25px;
  color:#d4d4d4;
  letter-spacing: 1px;
}
.subscribe_text_sm {
  font-family: Segoe, Arial;
  font-size:10pt;
  color:#fff;
}
.subscribe_btn {
  width:190px;
  height:48px;
  background-image:url('~@/assets/images/orange_button.png');
  opacity:1;
  color:#fff;
  font-size:22px;
  font-family: Segoe, Arial;
  font-weight: bold;
  letter-spacing: 1px;
}
.subscribe_btn:link {text-decoration: none;}
.subscribe_btn:hover {color:#d4d4d4;text-decoration: none;}
.float {float: left;}
.gold {color:#ffc12a;}
#close_x {
  position: absolute;
  top:10px;
  right:15px;
  color:#888;
  cursor: pointer;
}
#close_x:hover {
  color:#eee;
}

@media (max-width: 530px) {
  #footer_links .wrapper .card {
    display: table;
    margin: 0 auto;
  }
}

@media (min-width: 531px) and (max-width: 699px) {
  #footer_links .wrapper {
    width: calc(100%/3);
    height: 330px;
  }
  #footer_links .wrapper:nth-child(n+3):nth-child(-n+4) {
    height: 330px;
  }
  #footer_links .wrapper:nth-child(2) .card,
  #footer_links .wrapper:nth-child(5) .card {
    display: table;
    margin: 0 auto;
  }
}
@media (min-width: 700px) and (max-width: 1199px) {
  #footer_links .wrapper {
    width: calc(100%/4);
    height: 330px;
  }
  #footer_links .wrapper:nth-child(n+3):nth-child(-n+4) {
    height: 330px;
  }
  #footer_links .wrapper:nth-child(2) .card,
  #footer_links .wrapper:nth-child(5) .card {
    display: table;
    margin: 0 auto;
  }
}
@media (min-width: 1200px) and (max-width: 1474px) {
  #footer_links .wrapper {
    width: calc(100%/7);
  }
  #footer_links .wrapper:nth-child(3) .card {
    display: table;
    margin: 0 auto;
  }
}
@media (min-width: 1475px) {
  #footer_links .wrapper {
    width: calc(100%/7);
    height: auto;
  }
  #footer_links .wrapper:nth-child(4) .card {
    display: table;
    margin: 0 auto;
  }
}


/* Copyright */
#copyright {
  margin-top: 30px;
  color: #888;
  font-size: 14px;
  text-align: center;
}
#copyright a {
  margin: 0 10px;
  font-size: 14px;
  color: #888;
}
#copyright a:last-child {
  margin: 0 0 0 10px;
}
#copyright .mobile-divider {
  display: block;
  width: 0;
  height: 10px;
  opacity: 0;
}


@media (min-width: 475px) {
  #copyright .mobile-divider {
    display: inline-block;
    width: auto;
    opacity: 1;
  }
}
@media (min-width: 1035px) {
  #copyright p {
    float: left;
  }
  #copyright > div {
    float: right;
  }
}


/* Custom Large Switch with Check Icon Inside the Knob */
.custom-switch-lg .form-check-input {
  width: 2.75rem;
  height: 1.5rem;
  cursor: pointer;
}

/* Custom Large Switch Checked State */
.custom-switch-lg .form-check-input:checked {
  background-color: var(--bs-primary, #146ff8);
  border-color: var(--bs-primary, #146ff8);
  /* A single SVG containing a white circle with a dark/transparent check mark inside it */
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Ccircle cx='10' cy='10' r='7' fill='%23fff'/%3E%3Cpath fill='none' stroke='%23146ff8' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='m7.5 10 1.8 1.8 3.5-3.5'/%3E%3C/svg%3E");
  background-position: right center;
  background-size: contain;
}

/* Floating Cookie Settings Trigger Button Styles */
.cookie-float-btn {
  position: fixed;
  bottom: 25px;
  right: 25px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #146ff8;
  color: #ffffff;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  cursor: pointer;
  z-index: 9998; /* Underneath the cookie modal and open cookies container rules */
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.cookie-float-btn:hover {
  background-color: #0b5ed7;
  transform: scale(1.08);
}

.cookie-float-btn:focus {
  outline: none;
}

/* Shift button upward on smaller screens if Zoe's ADA widget is aligned bottom-right to avoid overlap */
@media (max-width: 767px) {
  .cookie-float-btn {
    bottom: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    font-size: 15px;
  }
}

.btn-sms {
  font-size: 0.875rem !important;
  padding: 0.25rem 0.5rem !important;
}

</style>